module.exports = __webpack_public_path__ + "static/media/submit.233c86bb.svg";